/**
 * Platform Package — auto-selects the correct destination provider.
 *
 * Web: FileSystemDirectoryHandle (File System Access API)
 * Android: Storage Access Framework
 * iOS: UIDocumentPicker / security-scoped URLs
 */

export * from './destination';
export * from './path-sanitizer';

// Platform-specific implementations
export { WebDestinationProvider } from './web';
export { AndroidDestinationProvider } from './android';
export { IOSDestinationProvider } from './ios';

import type { PlatformDestinationProvider } from './destination';
import { WebDestinationProvider } from './web';
import { AndroidDestinationProvider } from './android';
import { IOSDestinationProvider } from './ios';

function getPlatformName(): string {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    return 'web';
  }
  const rnPlatform = (globalThis as any).Platform;
  if (rnPlatform?.OS) {
    return rnPlatform.OS;
  }
  if (typeof process !== 'undefined') {
    if (process.env?.REACT_NATIVE_PLATFORM) return process.env.REACT_NATIVE_PLATFORM;
    if (process.platform === 'android') return 'android';
    if (process.platform === 'darwin') return 'ios';
  }
  return 'web';
}

export function getPlatformDestinationProvider(): PlatformDestinationProvider {
  const os = getPlatformName();
  if (os === 'web') {
    return new WebDestinationProvider();
  }
  if (os === 'android') {
    return new AndroidDestinationProvider();
  }
  if (os === 'ios') {
    return new IOSDestinationProvider();
  }

  return new WebDestinationProvider();
}
